goog.provide('el8.appchart.dialog.plrPreview');

goog.require('el8.appservice.notifier');
goog.require('el8.plrdata.base');
goog.require('el8.template.appchart.dialog.plrPreview');
goog.require('el8.template.render.reportFeedItem');
goog.require('el8.uiwidget.ButtonSet');
goog.require('el8.uiwidget.NewDialog');

/**
 * Analogous to the displayItem dialog but specifically for
 * viewing the more detailed version of PLR search results
 * before importing them.
 */
el8.appchart.dialog.plrPreview = (function() {

    var itemId = null;

    var DEFAULT_WIDTH = 570;
    var that = new el8.uiwidget.NewDialog({
        position: 'center',
        autoHeight: true,
        width: DEFAULT_WIDTH,
        showXButton: true
    });

    var buttonSet = new el8.uiwidget.ButtonSet();
    buttonSet.addButton(
        'sign', 'Sign & Import into My Chart', importFn, true
    );
    that.setButtonSet(buttonSet);

    var super_init = that._init;
    that._init = function() {
        super_init.call(that);
        that.getContentElt().on('click', '.download-pdf-trigger',  function() {
            var baseUrl = $('.pdf-holder', that.getContentElt()).attr('data');
            window.open(baseUrl + '&download=1');
        });
    };

    var super_show = that.show;
    that.show = function(_itemId, callbackFn) {
        itemId = _itemId;
        var item = el8.plrdata.getById(itemId);

        super_show.call(that);

        var title = getTitle(item);
        that.setTitle(title.substr(0, 73)); // stick to one line
        setContentForDocument(item);

        that.adjustPosition();

        $('img', that.getContentElt()).on('load', function() {
            that.adjustPosition();
        });
    };

    var super_hide = that.hide;
    that.hide = function() {
        super_hide.call(that);
        that.getContentElt().empty();
        itemId = null;
    };

    function getTitle(item) {
        var collab = el8.ptdata.plrCollaborators.getByKey(item.getPatientId());
        return el8.template.appchart.dialog.plrPreview.dialogTitle({
            item: item.asSoyMap(),
            collab: collab ? collab.asSoyMap() : {}
        });
    }

    function setContentForDocument(item) {
        var soyMap = {
            patient: el8.ptdata.currPatient.asSoyMap(),
            practice: el8.data.currPractice.asSoyMap()
        };
        if (item.is('VisitNote')) {
            // visits have a custom soy map that we need to feed into the chart templates,
            // so we'll need to instantiate a copy of the model
            var visitModel = el8.ptdata.model.note.visit(item.getJson());
            soyMap.item = visitModel.asSoyMap();
            // we haven't actually imported this yet, but we'll turn off
            // anything that we would turn off when this is imported
            soyMap.item.isImportedNote = true;
            var $content = $(el8.template.appchart.dialog.plrPreview.contentVisitHtml(soyMap));
            $('.addToNoteHpiTrigger', $content).remove();
            $('.el8ItemHover', $content).removeClass('el8ItemHover');
            if (soyMap.item.images.length) {
                that.setWidth(800);
            } else {
                that.setWidth(DEFAULT_WIDTH);
            }

            that.setContent($content);

        } else if (item.is('NonvisitNote')) {
            // nonvisits have a custom soy map that we need to feed into the chart templates,
            // so we'll need to instantiate a copy of the model
            var nonvisitModel = el8.ptdata.model.note.nonvisit(item.getJson());
            soyMap.item = nonvisitModel.asSoyMap();
            // we haven't actually imported this yet, but we'll turn off
            // anything that we would turn off when this is imported
            soyMap.item.isImportedNote = true;

            var $content = $(el8.template.appchart.dialog.plrPreview.contentNonvisitHtml(soyMap));
            if (soyMap.item.images.length) {
                that.setWidth(800);
            } else {
                that.setWidth(DEFAULT_WIDTH);
            }

            that.setContent($content);

        } else if (item.is('Report')) {
            // reports also depend on a custom soy map for grids
            var reportModel = el8.ptdata.model.report(item.getJson());
            $.extend(soyMap, reportModel.asSoyMap());
            that.setWidth(DEFAULT_WIDTH);
            that.setContent(el8.template.appchart.dialog.plrPreview.contentReport(soyMap));

            var $elt = that.getContentElt();
            // Add hover "reference range" messages
            $elt.find('.labValue').each(function() {
                var hoverMsg = el8.template.appchart.reportFeeds.qtipLabResult({
                    value: $(this).attr('value'),
                    refRange: $(this).attr('refRange'),
                    abnormalDescription: $(this).attr('abnormalDesc'),
                    abnormalFlag: $(this).attr('abnormalFlag'),
                    documentingPersonnelName: $(this).attr('documenter'),
                    labFacilityName: $(this).attr('loc')
                });
                el8.service.tooltip.create({
                    anchor: $(this),
                    text: hoverMsg
                });
            });
            // Add hover "reference range and date" messages to previous values
            $elt.find('.labPreviousValue').each( function() {
                var hoverMsg = $(this).attr('resultinfo');
                el8.service.tooltip.create({
                    anchor: $(this),
                    text: hoverMsg
                });
            });

        } else if (el8.model.identify.isOrder(item)) {
            $.extend(soyMap, item.asSoyMap());
            var templateFn;
            switch (item.getModelClass()) {
                case 'LabOrder':
                    templateFn = el8.template.render.reportFeedItem.contentLabOrder;
                    break;
                case 'CardiacOrder':
                case 'ImagingOrder':
                case 'PulmonaryOrder':
                case 'SleepOrder':
                    templateFn = el8.template.render.reportFeedItem.contentAncillaryOrder;
                    break;
            }
            that.setWidth(DEFAULT_WIDTH);
            that.setContent(templateFn(soyMap));

        }
    }

    function importFn() {
        buttonSet.disable();

        var item = el8.plrdata.getById(itemId);

        el8.appservice.notifier.notify('Signing this document into your chart...');
        el8.util.amplitude.logPLRChronologicalImportFromPreviewItem();
        $.el8_ajax({
            type: 'POST',
            url: el8.service.urls.get('plrChartImportItem', [item.getPatientId(), item.getId()]),
            success: function(data) {
                el8.appservice.notifier.notify('Document has been signed into your chart.');
                var mClass = data.new_item.model_class;
                var entitySet = el8.ptdata.getEntitySet(mClass);
                entitySet.create(data.new_item);
                buttonSet.enable();
                that.hide();

                el8.appchart.mainFeeds.plrNotification.refresh();
                el8.appchart.mainFeeds.chart.refreshChartSearch();
            },
            error: function() {
                buttonSet.enable();
            }
        });
    }


    return that;

})();
